import { Group } from "@mantine/core";
import { Outlet } from "react-router-dom";

const AgentsPageWrapper = () => {
  return (
    <Group wrap="nowrap" flex={1} h={"100%"} gap={0} align="start">
      <Outlet />
    </Group>
  );
};

export default AgentsPageWrapper;
